import { gql } from 'apollo-boost'

export const SEND_CC = gql`
mutation($cvc: String,$name:String,$expiry: String,$number: String,$zipcode: String){
  collectCreditCard(cc: { cvc: $cvc, name:$name, expiry:$expiry, number: $number, zipcode:$zipcode})
}
`